import { useContext } from 'react'
import { NavCtx } from './NavCtx'

export const useNav = () => useContext(NavCtx)
